import { Pie } from "@ant-design/plots";
import { CHART_TITLE_COLOR, CHART_VALUE_COLOR } from "../../../lib/constants";
import { memo, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { ACCOUNT_STATUSES } from "../../../lib/constants";
import ROUTES from "../../../configs/routesConfig";

type PieChartCardProps = {
  data: any;
  colors: string[];
  source: 1 | 2;
};

const PieChartCard = ({ data, colors, source }: PieChartCardProps) => {
  const navigate = useNavigate();

  const config: any = useMemo(
    () => ({
      legend: {
        position: "bottom",
        layot: "horizontal",
        flipPage: false,
        itemWidth: 149,
        spacing: 20,
        itemName: {
          formatter: (text: string) => `${text}:`,
        },
        itemValue: {
          formatter: (text: string) => {
            const value = data.filter((item: any) => item.type === text)[0]
              .value;
            return value.toLocaleString();
          },
          style: {
            fontSize: 14,
            fontWeight: 500,
          },
        },
      } as const,
      appendPadding: 10,
      data,
      padding: [0, 45, 50, 45],
      theme: "light",
      angleField: "value",
      colorField: "type",
      color: colors,
      radius: 0.7,
      innerRadius: 0.85,
      meta: {
        value: {
          formatter: (v: string) => `${v.toLocaleString()}`,
        },
      },
      label: {
        formatter: () => "",
      },
      statistic: {
        title: {
          style: {
            color: CHART_TITLE_COLOR,
            fontSize: "14px",
          },
          offsetY: 20,
        },
        content: {
          style: {
            color: CHART_VALUE_COLOR,
            fontSize: "24px",
            fontWeight: "500",
          },
          offsetY: -22,
          customHtml: (_c: any, _v: any, _d: any, data: any) => {
            const value = data.reduce((r: any, d: any) => r + d.value, 0);
            return value.toLocaleString();
          },
        },
      },
      pieStyle: {
        lineWidth: 0,
        cursor: "pointer",
      },
      onReady: (plot: any) => {
        plot.on("element:click", (args: any) => {
          const type = args.data.data.type;

          if (source === 1) {
            const status = ACCOUNT_STATUSES.find(
              (item: any) => item.label === type,
            );

            if (!["Semi-active", "Active", "Inactive"].includes(type)) {
              navigate(
                `${ROUTES.ACCOUNTS}?statusFilter=${status?.value}&isOther=false`,
              );
            } else {
              const nextPaymentFilter: string =
                type === "Active" ? "1" : type === "Semi-active" ? "2" : "3";

              let url: string = `${ROUTES.ACCOUNTS}?statusFilter=0&dateFilterNextPayment=${nextPaymentFilter}&isOther=false`;

              navigate(url);
            }
          } else {
            navigate(
              `${ROUTES.CUSTOMERS}?typeId=${type === "Individual" ? 1 : 2}`,
            );
          }
        });
      },
      state: {
        active: {
          animate: { duration: 100, easing: "easeLinear" },
          style: (item: any) => {
            return {
              stroke: item.data.color,
              lineWidth: 3,
              cursor: "pointer",
            };
          },
        },
      },
      interactions: [
        {
          type: "element-active",
        },
      ],
    }),
    [data, colors, source, navigate],
  );
  return (
    <div>
      <Pie {...config} />
    </div>
  );
};

export default memo(PieChartCard);
